<template>
  <div v-if="isLoading">Loading...</div>
  <div v-else-if="isError">
    Something went wrong:
    {{ error && (error as any).response?.data?.error }}
  </div>
  <div v-else-if="data">
    <div>
      <h1 class="text-2xl font-bold mb-4">Accept Invitation</h1>
      <p class="mb-4">
        You have been invited to join <span class="font-bold">{{ data.data.workspace.name }}</span> by
        <span class="font-bold">{{ data.data.invited_by }}</span>
      </p>
      <p class="mb-4">Please choose a password to accept the invitation and start using the app.</p>
    </div>
    <FormKit type="form" @submit="handleSubmit" submit-label="Accept Invitation">
      <FormKit type="password" name="password" label="Password" validation="required" />
      <FormKit type="password" name="password_confirmation" label="Password Confirmation" validation="required|confirm:password" />
      <FormKit type="hidden" name="invitation_token" :value="invitationToken" />
    </FormKit>
  </div>
</template>

<script setup lang="ts">
import httpClient from '@/utils/httpClient'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'
import router from '../questionnaireRouter'
import { successNotification } from '@/utils/notifications'

const invitationToken = useRoute().params.invitationToken as string
const { isLoading, isError, data, error } = useQuery({
  queryKey: ['invitation', invitationToken],
  queryFn: () => httpClient.get(`/v1/accounts/invitation/accept?invitation_token=${invitationToken}`),
  retry: false,
})

type AcceptInvitationFormData = {
  invitation_token: string
  password: string
  password_confirmation: string
}

const { mutateAsync } = useMutation({
  mutationFn: (formData: AcceptInvitationFormData) => httpClient.put(`/v1/accounts/invitation`, { account: formData }),
  onSuccess: () => {
    successNotification('Account Confirmed - Please login now')
    router.push({ name: 'login' })
  },
})

const handleSubmit = (formData: AcceptInvitationFormData) => {
  return mutateAsync(formData)
}
</script>
